import { getCompany } from '../components/API/company';
import { v4 as uuidv4 } from 'uuid';

export const pendo = window['pendo'];

export async function updatePendoInfo(
  user: Record<string, unknown>,
  signedIn: boolean,
) {
  if (signedIn) {
    const company = await getCompany();
    const { name: storeName, sellerStore, sellerType } = company || {};
    const firstName = user['custom:first_name'];
    const lastName = user['custom:last_name'];
    const email = user?.email;

    pendo?.identify({
      visitor: {
        id: uuidv4(),
        email,
        firstName,
        lastName,
        storeName,
        sellerType,
        platform: sellerStore,
      },
      account: {
        id: email,
        firstName,
        lastName,
        storeName,
        sellerType,
        platform: sellerStore,
      },
    });
  } else {
    pendo?.identify({
      visitor: {},
      account: {},
    });
  }
}
